import { otaUpdatesUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";

export const getInstallConfigurationBackupStatus = async (
  namespace: string,
  update_id: string,
) => {
  const url = otaUpdatesUrlEnvVar();
  const headers = {
    ...buildAxiosAuthenticationHeaders(),
  };

  try {
    const response = await axios.get(
      `${url}/api/v1/ns/${namespace}/installation/status`,
      {
        params: { update_id },
        headers,
      },
    );

    return response.data;
  } catch (err) {
    if (isAxiosError(err)) {
      const message =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        "Failed to fetch configuration backup install status. Please try again later.";
      throw new Error(message);
    } else {
      throw new Error(
        "An unexpected error occurred while fetching configuration backup install status.",
      );
    }
  }
};
